import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';

type Props = {
  label?: string;
  fallback?: string;
};

export function BackButton({ label = 'Volver', fallback = '/' }: Props) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
    >
      <ArrowLeft className="h-4 w-4" /> {label}
    </button>
  );
}
